import React from 'react';
import { ConfidenceRanking } from 'dea-core';

const question =
  'I know how prescription opioid misuse, illicit fentanyl use, and heroin use impact daily environments and the role of prevention science.';

export default {
  title: 'What Do You Think? Question 2',
  path: '/explore/confidence-ranking-2',
  content: <ConfidenceRanking question={question} />
};



// WEBPACK FOOTER //
// ./src/data/explore/ConfidenceRanking2.js